import { createRef } from 'react';

export const canvasRef = createRef<HTMLDivElement>();
export const scrollContainerRef = createRef<HTMLDivElement>();
export const svgRef = createRef<SVGSVGElement>();
export const chatEndRef = createRef<HTMLDivElement>();
